import { PaletteMode } from '@mui/material';

export const light = {
  alternate: {
    main: '#e6eef8',
    dark: '#edf1f7',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  mode: 'light' as PaletteMode,
  primary: {
    main: '#18759d',
    light: '#1a86b6',
    dark: '#104e6a',
    contrastText: '#fff',
  },
  secondary: {
    light: '#ffb74d',
    main: '#f9b934',
    dark: '#FF9800',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#1e2022',
    secondary: '#353D45', //'#677788',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#ffffff',
    default: '#ffffff',
    level2: '#e0e0e0',
    level1: '#ededed',
    sewp: '#31255b',
    },
  info: {
      main: '#18759d',
      light: '#1a86b6',
      dark: '#104e6a',
      contrastText: '#fff',
  },
};

export const dark = {
  alternate: {
    main: '#1a2138',
    dark: '#151a30',
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark' as PaletteMode,
  primary: {
    main: '#619db7',
    light: '#86d2ff',
    dark: '#619db7',
    contrastText: '#fff',
  },
  secondary: {
    light: '#FFEA41',
    main: '#FFE102',
    dark: '#DBBE01',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#DADBDD',//'#AEB0B4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  // background: {
  //   paper: '#222B45',
  //   default: '#222B45',
  //   level2: '#333',
  //   level1: '#2D3748',
  // },
  background: {
    paper: '#2E344F', // Significantly lightened for more contrast
    default: '#222B45', // Unchanged as a base contrast point
    level2: '#2B2F48', // Lightened for contrast against paper and default
    level1: '#343A55', // Further lightened for contrast against level2
    sewp: '#3d2e72'
    },
  info: {
      main: '#619db7',
      light: '#86d2ff',
      dark: '#508298',
      contrastText: '#1A2138',
  },
};
